export enum Status {
  SUCCEEDED = "SUCCEEDED",
  RUNNING = "RUNNING",
  INCOMPLETE = "INCOMPLETE",
  FAILED = "FAILED",
  CREATED = "CREATED",
  PENDING = "PENDING",
  CRASHED = "CRASHED",
}
